import { render, staticRenderFns } from "./CartButtonV2.vue?vue&type=template&id=fec24044"
import script from "./CartButtonV2.vue?vue&type=script&lang=js"
export * from "./CartButtonV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports